import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, amount: 0.15 }}
        transition={{ duration: 0.8, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLines = ({ lines, className = "", delay = 0, stagger = 0.14 }) => (
    <span className={`block ${className}`}>
        {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
                <motion.span
                    className="block will-change-transform"
                    initial={{ y: "112%" }}
                    animate={{ y: 0 }}
                    transition={{ duration: 1.05, delay: delay + i * stagger, ease: EASE }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </span>
);
